



























































import Vue from 'vue'
import SeismicForm from '@/models/SeismicForm'
import PointsParticuliers from '@/components/SeismicInsepctionForm/_PointsParticuliers.vue'

export default Vue.extend({
  name: 'SimpleTrunk1',
  components: {
    PointsParticuliers
  },
  props: {
    form: { type: [SeismicForm, Object] }
  },
  data () {
    return {
      specificPoints: [] as Array<string>
    }
  },
  beforeDestroy () {
    this.$emit('saveForm', this.form)
  },
  methods: {

  }
})

